import { AdminGuardService } from '../../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
import {MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { AuthService } from '../../../servicios/auth.service';
import { UserGuardService } from '../../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../../servicios/guards/multi-user.service';
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { read } from 'cfb/types';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';

//ngx-webcam 1
import {Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { environment } from "environments/environment";

@Component({
  selector: 'app-plandecuentas',
  templateUrl: './plandecuentas.component.html',
  styleUrls: ['./plandecuentas.component.css']
})
export class PlandecuentasComponent implements OnInit {
  @ViewChild('REPORTE') reporte: ElementRef;
  loading;
  dataSourceReporte = new MatTableDataSource();
  fecha_hoy;
  hoy;

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    //snackbar 2
    public snackBar: MatSnackBar
  ) { 
    this.loading=false;
    this.fecha_hoy = new Date;
    this.fecha_hoy =  this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
    this.hoy=this.fecha_hoy;
  }

  ngOnInit() {
  }

  //mandioca2019 (exporta datasource)
  exportExcel(data: any[]){
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, `PlanDeCuentas_${this.hoy}.xls`, { bookType: 'xls', type: 'buffer' });
 }


 exportAsExcelReporte() {
  console.log("Generando reporte..");
  this.exportExcel(this.dataSourceReporte.data);
}

 getRepo(){
  this.loading=true;
  //http://localhost:1337/api/getplancuentas/get
  this.http.get(`${environment.backendUrl}/api/getplancuentas/get`)
  .subscribe((datos: any[]) => {
    if (datos){
      console.log("se encontraron datos!");
      this.dataSourceReporte.data = datos;
      console.warn(this.dataSourceReporte.data);
      this.exportAsExcelReporte();
      this.loading=false;
    }else{
      console.log("no hay datos..");
      this.loading=false;
    }
  });
}
}
